import styled from 'styled-components';
import media from 'styles/media';
import PillButton from 'components/buttons/PillButton';

export const FilterGrid = styled.div`
  ${({ showImage, gap }) =>
    showImage
      ? `
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 1fr 1fr;
    `
      : `
    display: flex;
    gap: ${gap};
    flex-wrap: wrap;
    `}

  width: 100%;
  margin-bottom: 30px;

  ${media.medium`
    gap: 15px;
    `}
  ${media.small`
    grid-template-columns: 1fr 1fr ;
    `}
`;

export const CurrentOptionsWrap = styled.div`
  width: 100;
  height: 100%;
`;

export const Button = styled(PillButton)`
  margin-left: 5px;
  @media (max-width: 389px) {
    display: block;
    margin-bottom: 5px;
  }
`;
